import { createReducer, on } from '@ngrx/store'
import { OrderInfoActions } from './data.actions'
import { DataState } from './data.state'

function getInitState(): DataState {
  return {
    element: [
      // {
      //   name: 'Test',
      //   status: 'finished',
      //   date: '12.06.2022',
      //   price: '25,95€',
      //   type: 'article',
      //   description: 'test 1',
      //   uuid: '1234',
      //   paymentId: '',
      // },
      // {
      //   name: 'Konferenz in Ulm',
      //   status: 'appointment',
      //   date: '30.05.2021',
      //   price: '12.299,00€',
      //   type: 'event',
      //   description: 'test 2',
      //   uuid: '1234',
      //   paymentId: '',
      // },
      // {
      //   name: 'Bsp. Magazin',
      //   status: 'delivery',
      //   date: '24.02.2020',
      //   price: '19,99€',
      //   type: 'abo',
      //   description: 'test 3',
      //   uuid: '1234',
      //   paymentId: '',
      // },
      // {
      //   name: 'Lorem ipsum',
      //   status: 'finished',
      //   date: '29.08.2019',
      //   price: '12,30€',
      //   type: 'digital content',
      //   description: 'test 4',
      //   uuid: '1234',
      //   paymentId: '',
      // },
      // {
      //   name: 'for 30 days',
      //   status: 'delivery',
      //   date: '15.07.2022',
      //   price: '753,00€',
      //   type: 'article',
      //   description: 'test 5',
      //   uuid: '1234',
      //   paymentId: '',
      // },
    ],
  }
}

export const orderElementsReducer = createReducer<DataState>(
  getInitState(),
  on(
    OrderInfoActions.orderInfoSuccess,
    (state, action): DataState => ({
      ...state,
      element: action.payload,
    }),
  ),
)
